(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.evomoovVideoModal = {
    attach: function (context, settings) {
      once('evomoov-video-modal', '.evomoov-video__modal', context).forEach(function (modal) {
        UIkit.util.on(modal, 'shown', function () {
          modal.style.display = 'flex';
        });

        UIkit.util.on(modal, 'hide', function () {
          var video = modal.querySelector('video');
          if (video) {
            video.pause();
          }
        });
      });

      once('evomoov-video-inline', '[data-tpg-video-inline]', context).forEach(function (container) {
        var playBtn = container.querySelector('.evomoov-video__play-btn--inline');
        var thumbnail = container.querySelector('.evomoov-video__thumbnail');
        var player = container.querySelector('.evomoov-video__inline-player');

        if (playBtn && thumbnail && player) {
          playBtn.addEventListener('click', function () {
            // Capture the container's real width while thumbnail is still
            // visible, before the flex parent can lose its size reference.
            var width = container.getBoundingClientRect().width;

            thumbnail.hidden = true;
            player.hidden = false;

            if (width > 0) {
              container.style.width = width + 'px';
            }

            var video = player.querySelector('video');
            if (video) {
              video.play();
            }
          });
        }
      });
    }
  };

})(Drupal, once);